import React, { useState } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const YoutubeVids = ({ videos }) => {
  const [loadedVideos, setLoadedVideos] = useState({});

  // Extract video ID from YouTube URL
  const getVideoIdFromUrl = (url) => {
    // Handle different YouTube URL formats
    if (!url) return null;

    // For embed URLs: https://www.youtube.com/embed/VIDEO_ID
    if (url.includes('/embed/')) {
      return url.split('/embed/')[1].split('?')[0];
    }

    // For watch URLs: https://www.youtube.com/watch?v=VIDEO_ID
    if (url.includes('youtube.com/watch')) {
      const urlParams = new URLSearchParams(url.split('?')[1]);
      return urlParams.get('v');
    }

    // For youtu.be URLs: https://youtu.be/VIDEO_ID
    if (url.includes('youtu.be/')) {
      return url.split('youtu.be/')[1].split('?')[0];
    }

    return null;
  };

  const handleVideoLoad = (id) => {
    setLoadedVideos((prev) => ({ ...prev, [id]: true }));
  };

  if (!videos?.length) {
    return (
      <div className="mt-2">
        <h1 className="mb-2 font-bold text-lg">Suggested Videos:</h1>
        <p className="text-gray-600">No videos available.</p>
      </div>
    );
  }

  return (
    <div>
      <div className="px-1 space-y-3">
        {videos.map((video, index) => {
          const videoId = getVideoIdFromUrl(video.url);
          if (!videoId) return null;

          return (
            <div key={`${videoId}-${index}`} className="flex flex-col">
              <div className="relative w-full h-0 pb-[56.25%] rounded-lg overflow-hidden shadow-md bg-gray-100">
                {!loadedVideos[videoId] && (
                  <div className="absolute inset-0 flex flex-col items-center justify-center">
                    <Skeleton className="absolute top-0 left-0 w-full h-full rounded-lg" />
                    {video.thumbnail && (
                      <img
                        src={video.thumbnail}
                        alt={video.title || 'Video thumbnail'}
                        className="absolute top-0 left-0 w-full h-full object-cover opacity-50"
                      />
                    )}
                  </div>
                )}
                <iframe
                  src={`https://www.youtube.com/embed/${videoId}`}
                  title={video.title || `YouTube Video ${videoId}`}
                  className={`absolute top-0 left-0 w-full h-full border-0 ${
                    loadedVideos[videoId] ? 'opacity-100' : 'opacity-0'
                  }`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  onLoad={() => handleVideoLoad(videoId)}
                />
              </div>
              {/* {video.title && (
                <h3 className="mt-2 text-sm font-medium line-clamp-2">{video.title}</h3>
              )} */}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default YoutubeVids;
